import { render, staticRenderFns } from "./TemplateDetailModal.vue?vue&type=template&id=e13336e2&scoped=true&"
import script from "./TemplateDetailModal.vue?vue&type=script&lang=js&"
export * from "./TemplateDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDetailModal.vue?vue&type=style&index=0&id=e13336e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13336e2",
  null
  
)

export default component.exports